import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'
import MerchantInboundRejectReturnStatusBadge from 'domains/merchant-inbound-reject-return/atoms/status-badge'
import { STATUS } from 'domains/merchant-inbound-reject-return/constants'
import MerchantBadge from 'domains/merchant/atoms/merchant-badge'
import { MERCHANT_TYPE } from 'domains/merchant/constants'
import PropTypes from 'prop-types'
import React from 'react'
import TimeUtil from 'utils/time-util'


const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const filterPropTypes = {
  column: PropTypes.object
}

/**
 * Merchant Inbound Reject Return Table Columns
 */
const merchantInboundRejectReturnTableColumns = ({
  buttonText,
  buttonColour,
  onButtonClick
}) => {

  const MerchantTypeFilter = ({ column }) => {
    const options = Object.keys(MERCHANT_TYPE).map((key) => (
      {
        label : MERCHANT_TYPE[key],
        value : MERCHANT_TYPE[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const StatusFilter = ({ column }) => {
    const options = Object.keys(STATUS).map((key) => (
      {
        label : STATUS[key],
        value : STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // Custom Cell
  // Used to modify the cell in specific columns
  const MerchantTypeCell = (row) => <MerchantBadge merchant_type={ row.cell.value } />

  const StatusCell = (row) => <MerchantInboundRejectReturnStatusBadge status={ row.cell.value } />

  const DateCell = (row) => TimeUtil.format(row.cell.value)

  const ActionCell = ({ cell: { row } }) => (
    <RowButton
      data={ row.original }
      color={ buttonColour }
      onClick={ onButtonClick }
      text={ buttonText }
    />
  )

  MerchantTypeFilter.propTypes = filterPropTypes
  StatusFilter.propTypes       = filterPropTypes
  ActionCell.propTypes         = actionCellPropTypes

  return (
    [
      {
        Header   : 'Code',
        accessor : 'code'
      },
      {
        Header   : 'Inbound Code',
        accessor : 'inbound_code'
      },
      {
        Header  : 'Merchant',
        columns : [
          {
            Header   : 'Name',
            accessor : 'merchant.name',
            id       : 'merchant_name'
          },
          {
            Header   : 'Code',
            accessor : 'merchant.code',
            id       : 'merchant_code'
          },
          {
            Header   : 'Email',
            accessor : 'merchant.email',
            id       : 'merchant_email'
          },
          {
            Header   : 'Type',
            accessor : 'merchant.merchant_type',
            id       : 'merchant_type',
            Cell     : MerchantTypeCell,
            Filter   : MerchantTypeFilter
          }
        ]
      },
      {
        Header         : 'Qty',
        accessor       : 'total_quantity',
        disableFilters : true
      },
      {
        Header         : 'Created At',
        accessor       : 'created_at',
        Cell           : DateCell,
        disableFilters : true
      },
      {
        Header         : 'Scheduled At',
        accessor       : 'scheduled_at',
        Cell           : DateCell,
        disableFilters : true
      },
      {
        Header   : 'Status',
        accessor : 'status',
        Cell     : StatusCell,
        Filter   : StatusFilter
      },
      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

export default merchantInboundRejectReturnTableColumns
